import { isUndefined, noop } from 'lodash/fp';
import React, { useMemo } from 'react';

import { getSmileyIcon } from '../../admin/risk-tolerance/utils';
import { Icon } from '../icon/Icon';
import styles from './SharedAnalytics.module.scss';
import { RiskToleranceIndicator } from '../../admin/risk-tolerance/store';

interface RiskToleranceSingleIndicatorProps {
    riskIndicator: RiskToleranceIndicator;
    fontSize?: number;
    onClick?: () => void;
    canClick?: boolean;
}

export const RiskToleranceSingleIndicator: React.FC<RiskToleranceSingleIndicatorProps> = ({ riskIndicator, fontSize = 36, onClick = noop, canClick = false }) => {
    const { indicator, fill, color, borderColor } = riskIndicator;
    const style = useMemo(() => ({ fill, color, fontSize }), [fontSize, color, fill]);
    const icon = getSmileyIcon(indicator);

    const borderStyle = useMemo(() => isUndefined(borderColor) ? { height: `${fontSize}px`, width: `${fontSize}px` } : { height: `${fontSize}px`, width: `${fontSize}px`, border: `2px solid ${borderColor}` }, [borderColor, fontSize]);

    if (canClick) {
        return (
            <button className={styles.answerIndicatorButton} onClick={onClick} style={borderStyle}>
                <Icon icon={icon} {...style} />
            </button>
        );
    }

    return (
        <div className={styles.answerIndicator} style={borderStyle}>
            <Icon icon={icon} {...style} />
        </div>
    );
};
